import { useUserHasFeature, useUserSession } from '@solinkcorp/authentication';
import { useState } from 'react';
import { PERSISTENT_PREFIX } from 'src/core/utils/StorageAPI';
import { DEFAULT_VERIFICATION_WORKFLOW_ID } from 'vd-constants';

export const localStorageVerifEyeKey = PERSISTENT_PREFIX + 'VERIFEYE_PHONE_NUMBER';

export interface VerifyEyeLocalStorage {
  email: string;
  phoneNumber: string;
  timestamp: number;
}

export interface UseVerifEyePhoneModal {
  verifEyePhoneModalOpen: boolean;
  setVerifEyePhoneModalOpen: (modalOpen: boolean) => void;
  showVerifEyePhoneModal: boolean;
}

export default function useVerifEyeModal(): UseVerifEyePhoneModal {
  const user = useUserSession();

  const [verifEyePhoneModalOpen, setVerifEyePhoneModalOpen] = useState(false);

  const verifEyeWorkflowId =
    user.profile.metadata.verifEyeWorkflowId || DEFAULT_VERIFICATION_WORKFLOW_ID;

  const showVerifEyePhoneModal =
    useUserHasFeature('enableAlarmVerification') && verifEyeWorkflowId === 'alarms';

  return {
    verifEyePhoneModalOpen,
    setVerifEyePhoneModalOpen,
    showVerifEyePhoneModal,
  };
}
